// src/components/Modal.jsx
import React, { useEffect } from "react";
import ReactDOM from "react-dom";

const Modal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (!isOpen) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKey);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", handleKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-60 flex items-start justify-center bg-black/70 backdrop-blur-sm pt-36 sm:pt-44 md:pt-48"
      // ↑ added more padding at the top so modal moves further down
      onClick={onClose}
    >
      <div
        className="relative bg-black rounded-lg overflow-hidden shadow-2xl w-[90%] max-w-3xl aspect-video"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close (×) */}
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute -top-10 right-0 text-white text-3xl font-light hover:text-gray-300"
        >
          ×
        </button>

        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
